import { inputCls, labelCls, btnQuiet } from '../../../ui/styles';
import { MONTHS, daysInMonth } from './profileRules';
import type { Customer } from '../../../core/types/account';
type Birthday = NonNullable<Customer['birthday']>;
type Props = {
  value: Birthday | null;
  onChange: (b: Birthday | null) => void;
  error?: string;
};

/** Alleen dag en maand: het jaar is niet nodig voor een felicitatie, dus vragen we het niet. */
export function BirthdayFields({
  value,
  onChange,
  error
}: Props) {
  const month = value?.month ?? 0;
  const days = month ? daysInMonth(month) : 31;
  const set = (patch: Partial<Birthday>) => {
    const next = {
      day: value?.day ?? 0,
      month: value?.month ?? 0,
      ...patch
    };
    // Pas bewaren als allebei gekozen zijn; half ingevuld blijft in het formulier staan.
    onChange(next.day && next.month ? next : next.day || next.month ? next as Birthday : null);
  };
  return <div data-id="element-6750" data-mp="227u1veyehjhb">
      <div className="grid grid-cols-[6rem_1fr] gap-4 sm:max-w-sm" data-id="element-6751" data-mp="228dbm8dwd1k9">
        <div data-id="element-6752" data-mp="22a6jfr08xrtu">
          <label htmlFor="profile-birthday" className={labelCls} data-id="element-6753" data-mp="3prsa1eky78wx">
            Dag
          </label>
          <select id="profile-birthday" value={value?.day ?? ''} onChange={e => set({
          day: Number(e.target.value)
        })} autoComplete="bday-day" aria-invalid={error ? true : undefined} aria-describedby={error ? 'profile-birthday-error' : 'profile-birthday-hint'} className={inputCls} data-id="element-6754" data-mp="3uqv7odylmcuv">
            <option value="" data-id="element-6755" data-mp="36z7nsfzr8223">–</option>
            {Array.from({
            length: days
          }, (_, i) => i + 1).map(d => <option key={d} value={d} data-id="element-6756" data-mp="3g1yyueopwvt7">
                {d}
              </option>)}
          </select>
        </div>
        <div data-id="element-6757" data-mp="3ksyuzhq0j9un">
          <label htmlFor="profile-birthmonth" className={labelCls} data-id="element-6758" data-mp="3ktqomn01uxia">
            Maand
          </label>
          <select id="profile-birthmonth" value={month || ''} onChange={e => set({
          month: Number(e.target.value)
        })} autoComplete="bday-month" className={inputCls} data-id="element-6759" data-mp="2ncjprugm5czx">
            <option value="" data-id="element-6760" data-mp="3vms7a8p631z0">–</option>
            {MONTHS.map((m, i) => <option key={m} value={i + 1} data-id="element-6761" data-mp="3qo8lc8akpq6n" data-mpi={i}>
                {m}
              </option>)}
          </select>
        </div>
      </div>
      {error ? <p id="profile-birthday-error" className="mt-1.5 text-[13px] text-clay" data-id="element-6762" data-mp="89pxuvpvweo4">
          {error}
        </p> : <p id="profile-birthday-hint" className="mt-1.5 text-[13px] text-muted" data-id="element-6763" data-mp="4aqsja08qfw5">
          Geen jaar nodig. Alleen voor een felicitatie per mail, als je de nieuwsbrief krijgt.
        </p>}
      {value && <button type="button" onClick={() => onChange(null)} className={`${btnQuiet} mt-2`} data-id="element-6764" data-mp="3lp4e3n77m2iy">
          Weghalen
        </button>}
    </div>;
}